import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { AuthService } from "src/app/providers/auth.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { AssignJobForMembersComponent } from "src/app/shared/components/assign-job-for-members/assign-job-for-members.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { AttendanceMarkerComponent } from "../new-v2-component/attendance-marker/attendance-marker.component";
import { MatDialog } from "@angular/material/dialog";
import { DialogService } from "src/app/providers/dialog.service";
import { environment } from "src/environments/environment.prod";
import { Share } from "@capacitor/share";
import { AskBusinessRatingComponent } from "src/app/shared/components/ask-business-rating/ask-business-rating.component";

@Component({
  selector: "sm-membership-booking-details-page",
  templateUrl: "./membership-booking-details-page.component.html",
  styleUrls: ["./membership-booking-details-page.component.scss"],
})
export class MembershipBookingDetailsPageComponent implements OnInit,OnDestroy {
  loader: boolean = false;
  apisub: Subscription;
  membershipBookingsData: any = [];
    trackersData:any = []
  latestDate:any =null
  constructor(
    private navservice: NavigationService,
    private ls:LoaderServiceService,
    private router: Router,
    private route:ActivatedRoute,
    private apiservice: ApiService,
    private authService:AuthService,
    private dialog:MatDialog,
    private dialogService:DialogService
  ) {
    this.navservice.hideSidebarAndNav = false;
    
    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_MEMBER_SESSION_DETAILS){
        if(resdata.result){
        this.membershipBookingsData = resdata.result ? [resdata.result] : [];
        // this.membershipBookingsData = this.sortObjectsDescendingByBookingNumber(this.membershipBookingsData)

        this.membershipBookingsData.forEach((element: any) => {
         
          if (element.data_type == 2) {
            if (element.customerInfo) {
              element.customerInfo = JSON.parse(element.customerInfo);
              element.customerName = element.customerInfo.name;
              element.customerPhone = element.customerInfo.phone;
            }

            if (element.serviceInfo) {
              if (element.serviceInfo != null) {
                element.serviceInfo =
                  typeof element.serviceInfo == "string"
                    ? JSON.parse(element.serviceInfo)
                    : element.serviceInfo;
                element.servicesArray = [];
                element.serviceInfo.forEach((item: any) => {
                  element.servicesArray.push(" " + item.service_name);
                });
              }
            }
            if (element.custom_items) {
              if (element.custom_items != null) {
                element.custom_items =
                  typeof element.custom_items == "string"
                    ? JSON.parse(element.custom_items)
                    : element.custom_items;
                element.customItemsArray = [];
                element.custom_items.forEach((item: any) => {
                  element.customItemsArray.push(" " + item.item_name);
                });
              }
            }
             if (element.member_address) {
                if (element.member_address != null) {
                  element.member_address =
                    typeof element.member_address == "string"
                      ? JSON.parse(element.member_address)
                      : element.member_address;
                  
                }
              }
            if (element.appointment_products) {
              if (element.appointment_products != null) {
                element.appointment_products =
                  typeof element.appointment_products == "string"
                    ? JSON.parse(element.appointment_products)
                    : element.appointment_products;
                // element.customItemsArray = []
                // element.serviceInfo.forEach((item:any) => {
                //   element.customItemsArray.push(' ' + item.item_name)
                // });
              }
            }
            if (element.enrolled_member_timings) {
              if (element.enrolled_member_timings != null) {
                element.enrolled_member_timings =
                  typeof element.enrolled_member_timings == "string"
                    ? JSON.parse(element.enrolled_member_timings)
                    : element.enrolled_member_timings;
                // element.customItemsArray = []
                // element.serviceInfo.forEach((item:any) => {
                //   element.customItemsArray.push(' ' + item.item_name)
                // });
              }
            }

            if (element.entityInfo) {
              if (element.entityInfo != null) {
                element.entityInfo =
                  typeof element.entityInfo == "string"
                    ? JSON.parse(element.entityInfo)
                    : element.entityInfo;
                // element.customItemsArray = []
                // element.serviceInfo.forEach((item:any) => {
                //   element.customItemsArray.push(' ' + item.item_name)
                // });
              }
            }

            element.appointment_no = "---";
            element.costing = element.currency_symbol
              ? element.currency_symbol + element.price
              : "₹" + element.price;
            //  element.servicesArray = [element.serviceInfo]
            element.paymentStat = "---";
            if (element.customer_name == "null" || !element.customer_name) {
              element.cust_name = "New Customer";
            } else if (
              element.customer_name != "null" ||
              element.customer_name
            ) {
              element.cust_name = element.customer_name;
            }

            if (element.customer_phone == "null" || !element.customer_phone) {
              element.cust_phn = "---";
            } else if (
              element.customer_phone != "null" ||
              element.customer_phone
            ) {
              element.cust_phn =
                element.country_code + " " + element.customer_phone;
            }

            if (element.bookingStartTime && element.bookingStartTime != null) {
              element.bookingStartTime = element.bookingStartTime.slice(0, 5);
            }
            if (element.bookingEndTime && element.bookingEndTime != null) {
              element.bookingEndTime = element.bookingEndTime.slice(0, 5);
            }

            if (
              element.session_start_time &&
              element.session_start_time != null
            ) {
              element.bookingStartTime = element.session_start_time.slice(0, 5);
            }
            if (element.session_end_time && element.session_end_time != null) {
              element.bookingEndTime = element.session_end_time.slice(0, 5);
            }

            if (element.bookingStatus == 0) {
              element.bookingStat = "Absent";
            } else {
              if (element.session_status == 1) {
                element.bookingStat = "Assigned";
              } else if (element.session_status == 2) {
                element.bookingStat = "In-progress";
              } else if (element.session_status == 3) {
                element.bookingStat = "Completed";
              } else if (element.bookingStatus == 1) {
                element.bookingStat = "Present";
              } else {
                element.bookingStat = "---";
              }
            }

            if (!element.employeeName) {
              element.employeeName = "---";
            }

            if (element.bookingType == "1") {
              element.bType = "Shop";
            }
            if (element.bookingType == "0") {
              element.bType = "Home";
            }
            if (element.bookingType == "2") {
              element.bType = "Virtual";
            }


            if (element.billing_cycle == "1") {
              element.bcycle = "Weekly";
            }
            if (element.billing_cycle == "2") {
              element.bcycle = "Monthly";
            }
            if (element.billing_cycle == "3") {
              element.bcycle = "Yearly";
            }
            if (element.billing_cycle == "4") {
              element.bcycle = "3 Months";
            }
            if (element.billing_cycle == "5") {
              element.bcycle = "6 Months";
            }

             let isEntityForeign = element.currency == 'INR' ? '0' : '1'
if (this.bd && this.bd != null) {
                const weekdays = [
                  "Sunday",
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                ];
                const weekdayIndex = parseInt(this.bd, 10) - 1;
                element.u_booking_date = weekdays[weekdayIndex];
              }
            localStorage.setItem(SM_CONSTANTS.IS_ENTITY_FOREIGN,isEntityForeign)
          }
        });

        this.apiservice.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
          )
        );

        console.log(this.membershipBookingsData);
      }

         this.apiservice.getProgressTrackersForMember(this.memberHash)

      }
          if (resdata.responseType === SM_CONSTANTS.RESULT_API_GET_PROGRESS_TRACKERS_FOR_MEMBER) {
  this.trackersData = [];

  if (resdata.result) {
    this.trackersData = resdata.result;

    this.trackersData.forEach((element: any) => {
       element.tracking_logs =
              typeof element.tracking_logs == "string"
                ? JSON.parse(element.tracking_logs)
                : element.tracking_logs;

                    if (element.tracking_logs) {
              // create a sorted copy of logs (oldest first)
              const sortedLogs = [...element.tracking_logs].sort(
                (a: any, b: any) =>
                  new Date(a.creation_time).getTime() -
                  new Date(b.creation_time).getTime()
              );

               const reversersortedLogs = [...element.tracking_logs].sort(
                (a: any, b: any) =>
                  new Date(b.creation_time).getTime() -
                new Date(a.creation_time).getTime()
              );
              element.sortedLogs = reversersortedLogs

            }

    });

    // ✅ Find latest creation_time after parsing
    // ✅ Find latest creation_time after parsing
let latestDate: string | null = null;

this.trackersData.forEach((element: any) => {
  if (Array.isArray(element.tracking_logs)) {
    element.tracking_logs.forEach((log: any) => {
      const creationTime = log?.creation_time;
      if (creationTime) {
        if (!latestDate || creationTime > latestDate) {
          latestDate = creationTime;
        }
      }
    });
  }
});

this.latestDate = latestDate;
console.log("Latest Creation Time (raw):", this.latestDate);
  }

  this.loader = false;
  this.ls.showLoader = false;

   if(this.statusofUpdate == 3){
    this.statusofUpdate = 0
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Great work.',
            message : 'Would you want to add Fitness Progress data for this member now?',
            okbtn : "Yes, let's add",
            cancelbtn : 'No',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(data => {
          if(data){
              this.updateProgress()
          }
        })
          }
}
       if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ASSIGN_EMPLOYEE_TO_MEMBER
      ) {
        if(resdata.result){
          this.apiservice.getMemberSessionDetails(this.memberHash,this.bd)
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_UPDATE_MEMBER_SESSION
      ) {
        if(resdata.result){
          
          this.apiservice.getMemberSessionDetails(this.memberHash,this.bd)
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_MARK_MEMBER_ATTENDANCE_STATUS
      ) {
        if(resdata.result){
          this.apiservice.getMemberSessionDetails(this.memberHash,this.bd)
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_MEMBER_ATTENDANCE_DATA_BY_ENTITY
      ) {
        if(resdata.result){
          this.apiservice.getMemberSessionDetails(this.memberHash,this.bd)
        }
      }
    })
  }
memberHash:any
entityHash:any
isFuture:any
bd:any
isOwner:boolean = false
  ngOnInit(): void {
        this.isOwner = this.authService.isOwner();
    this.route.queryParams.subscribe(data => {
      if(data.memberHash){
        this.memberHash = data.memberHash
        this.entityHash = data.entityHash
        this.bd = data.bd
        this.isFuture = data.isf
        this.loader = true;
        this.ls.showLoader = true
        this.apiservice.getMemberSessionDetails(this.memberHash,this.bd)

      }
    })
  }


   changeAttendanceStatus(status: any, item: any) {
      console.log(item);
  
      let msg = "";
      if (status == 0) {
        msg = "Are you sure you want to mark this appointment as absent?";
      } else if (status == 1) {
        msg = "Are you sure you want to mark this appointment as present?";
      }
      const dialogRef = this.dialog.open(AttendanceMarkerComponent, {
        data: {
          title: "Alert",
          message: msg,
          status: status,
          okbtn: "Confirm",
          cancelbtn: "Cancel",
          type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
        },
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result) => {
        console.log(result);
        if (result) {
          let data = {
            hash_id: item.hash_id, // only while updating the attendance status
            entity_hash: item.entityHash,
            member_hash: item.member_hash_id,
            created_by_hash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
            attendance_status: status, //0-absent,1-present
            notes: result.note,
            attendance_date: this.formatDateForApi(new Date()),
          };
  
          Object.keys(data).forEach((key) => {
            if ((data as any)[key] === null) {
              delete (data as any)[key];
            }
          });
  
          console.log(data);
  
          this.ls.showLoader = true;
          this.apiservice.markMemberAttendanceStatus(data);
        }
      });
    }
    deleteAttendance(rowvalue: any) {
      const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
        width: "400px",
        data: {
          title: "Alert",
          message: "Are you sure you want to delete this member's attendance?",
          okbtn: "Yes",
          cancelbtn: "No",
          type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
        },
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result) => {
        console.log(result);
        if (result) {
          let data = {
            entityHash: rowvalue.entityHash,
            memberHash: rowvalue.member_hash_id
              ? rowvalue.member_hash_id
              : rowvalue.member_hash,
            attendanceHash: rowvalue.hash_id,
          };
  
          console.log(data);
          this.ls.showLoader = true;
          this.apiservice.deleteMemberAttendanceDataByEntity(data);
        }
      });
    }

      assignJobForMember(item: any) {
        let data = {
            title: "Assign job",
            ref: this.dialog,
            data: item,
          } 
        this.dialogService.openFullScreenDialog(AssignJobForMembersComponent, data);
      }
        statusofUpdate:any = 0

    operationForMember(item: any, status: any) {
        if(this.getAccessStatus()){
          this.ls.showLoader = true;
               this.statusofUpdate = status
          if (status == 2) {
            let obj = {
              memberHash: item.member_hash_id,
              entityHash: item.entityHash,
              employeeHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
              assignByHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
              sessionStatus: status,
              startTime: this.formatTimeForTime(new Date()),
              endTime: this.addOneHour(this.formatTimeForTime(new Date())),
              attendanceHash: item.hash_id,
            };
      
            this.apiservice.UpdateMemberSession(obj);
          }
          if (status == 3) {
            let obj = {
              memberHash: item.member_hash_id,
              entityHash: item.entityHash,
              employeeHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
              assignByHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
              sessionStatus: status,
              startTime: item.bookingStartTime.slice(0, 5),
              endTime: this.formatTimeForTime(new Date()),
              attendanceHash: item.hash_id,
            };
      
            this.apiservice.UpdateMemberSession(obj);
          }

    }
    else{
      const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
                width: "400px",
        data: {
          title: "Access denied",
          message:
            "You do not have access to this job. It's not assigned to you. Ask the corresponding person to assign the job to you.",
          okbtn: "Ok",
          cancelbtn: "Ok",
          type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
        },
        disableClose: true,
      });
    }
    }
  
  
    addOneHour(timeStr:any) {
    const [hours, minutes] = timeStr.split(':').map(Number);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
  
    // Add one hour
    date.setHours(date.getHours() + 1);
  
    // Format back to HH:mm
    const newHours = String(date.getHours()).padStart(2, '0');
    const newMinutes = String(date.getMinutes()).padStart(2, '0');
  
    return `${newHours}:${newMinutes}`;
  }
  
    formatTimeForTime(date: Date): string {
      const hours = date.getHours().toString().padStart(2, "0"); // Ensure two digits, pad with leading zero if necessary
      const minutes = date.getMinutes().toString().padStart(2, "0"); // Same for minutes
      return `${hours}:${minutes}`;
    }
  formatDateForApi(dateStr: Date) {
    // let curdate = new Date().toISOString().slice(0,10);
    // return curdate;

    let curdate = dateStr
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;

    // // Split the date string by `/`
    // const parts = dateStr.split('/');

    // // Reverse the order of the parts and join them with `-`
    // const newDateStr = parts.reverse().join('-');

    // // Return the formatted date string
    // return newDateStr;
  }

    opentorate(item: any) {
    let msg =
      environment.base_lookzup_market_website_url +
      "/session-details?attnId=" +
      item.hash_id;


    let data= {
      title: "Share details to rate",
      ref: this.dialog,
      data: msg,
      reference: item,
      entity_hash: this.entityHash,
      type:2

    }  
    this.dialogService.openFullScreenDialog(AskBusinessRatingComponent,data);
  }


  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }

    updateProgress(){
      if(this.getAccessStatus()){
        
        this.router.navigate(['tracking-item'], {
           queryParamsHandling: "merge",
          relativeTo: this.route,
          queryParams: {
            // hash:
            // mn: this.memberDetailsData.hash_id,
          },
          })   
    }
    else{
      const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
                width: "400px",
        data: {
          title: "Access denied",
          message:
            "You do not have access to this job. It's not assigned to you. Ask the corresponding person to assign the job to you.",
          okbtn: "Ok",
          cancelbtn: "Ok",
          type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
        },
        disableClose: true,
      });
    }
  }

     getAccessStatus(): boolean{
      if(this.isOwner) return true
      
      else{
        return this.membershipBookingsData[0].operation_access == 1 ? true : false
      }
  }


   goviewdetails(rowvalue: any) {
    // sessionStorage.setItem("mefrp", rowvalue.email);
    sessionStorage.setItem(
              "isEntityIndividual",
              rowvalue.entityInfo.revenue_model == 2 ? "1" : "0"
            );
    this.router.navigate(["member-details"], {
      relativeTo: this.route,
      queryParams: {
        // entityHash: this.entityHash,
        eph: rowvalue.entityInfo.public_hash,
        // memberHash: rowvalue.hash_id,
      },
      queryParamsHandling: 'merge'
    });
  }


   openLink(rowvalue: any): void {
    if (!rowvalue) return;

    let url = String(rowvalue).trim();

    // Check if the URL starts with http:// or https://
    // If not, prepend https:// to make it absolute
    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }

    window.open(url, "_blank");
  }


  openGoogleMaps(rowvalue: any): void {
    // Construct the Google Maps URL with the provided coordinates
    const mapUrl = `https://www.google.com/maps?q=${rowvalue.lat},${rowvalue.lng}`;

    // Sanitize the URL to make it safe for opening in a new tab
    // const sanitizedUrl: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(mapUrl);
    // console.log(sanitizedUrl.toString());

    // Open a new tab with the Google Maps URL
    window.open(mapUrl, "_blank");
  }
}
